import React from 'react';
import ReactDOM from 'react-dom/client'; // Ensure you're using React 18+ version
import App from './app/App';
import './index.css';

const rootElement = document.getElementById('root'); // This should match the ID in your index.html
if (rootElement) {
  const root = ReactDOM.createRoot(rootElement);
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
} else {
  console.error('Root element not found!');
}
